import { useEffect } from "react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import { GlossaryTermBody, termTitle } from "@/components/GlossaryInfo"
import { Card } from "@/components/ui/Card"
import { GLOSSARY } from "@/lib/glossary"

// Every stock and sales term in Atlas, with how it is counted (lib/glossary).
// The (i) popups link here with the term's id as the hash.
export default function GlossaryShow() {
  // The page scrolls inside the layout's pane, not the window, so the
  // browser's own jump to #term does not happen on load.
  useEffect(() => {
    const id = window.location.hash.slice(1)
    if (id) document.getElementById(id)?.scrollIntoView({ block: "start" })
  }, [])

  return (
    <AppLayout header={<PageTitle title="Glossary" subtitle="What each stock and sales number in Atlas means, and how it is counted" />}>
      <div className="max-w-3xl space-y-4">
        <Card className="p-4">
          <div className="mb-2 text-sm font-semibold">Terms</div>
          <div className="space-y-1.5 text-sm">
            {GLOSSARY.map((section) => (
              <div key={section.title} className="flex flex-wrap gap-x-4 gap-y-1">
                <span className="w-32 shrink-0 font-medium">{section.title}</span>
                {section.terms.map((term) => (
                  <a key={term.id} href={`#${term.id}`} className="text-link hover:underline">{term.term}</a>
                ))}
              </div>
            ))}
          </div>
        </Card>

        {GLOSSARY.map((section) => (
          <Card key={section.title} className="overflow-hidden">
            <div className="border-b bg-muted/60 px-4 py-2 text-sm font-semibold">{section.title}</div>
            <div className="divide-y">
              {section.terms.map((term) => (
                <section key={term.id} id={term.id} className="scroll-mt-4 px-4 py-3 target:bg-primary/5">
                  <h2 className="mb-1 text-base font-semibold">{termTitle(term)}</h2>
                  <GlossaryTermBody term={term} />
                </section>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </AppLayout>
  )
}
